import DirectInvitations from "./DirectInvitations";
import DirectInviteCard from "./DirectInviteCard";
import UniversalLinkCard from "./UniversalLinkCard";

export default function InvitesTab({ program }) {
    return (
        <div>
            <div className="two-columns gap-xs">
                <DirectInviteCard programId={program.id} />
                <UniversalLinkCard programId={program.id} />
            </div>
            <div className="v-spacer-xl"></div>
            <DirectInvitations programId={program.id} />
        </div>
    )
}
